<div class="betslipqd-container make-deposit mt-2" (window:resize)="onResize()">
    @if (authDetails() && authDetails().authFlag && isLoggedin() && sessionInfo()) {
        <app-qd />
    }
    @if (!isLoggedin()) {
        <div class="error-page">
            <span class="theme-info-i"></span>
            <h3>
                {{ 'PARTY.CASHIER.web.deposit.session.expire.message' | translate }}
            </h3>
        </div>
    }

    <bqd-loader />
</div>
